import script from "./PostCodeForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostCodeForm.vue?vue&type=script&lang=ts&setup=true"

import "./PostCodeForm.vue?vue&type=style&index=0&id=beff495c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beff495c"]])

export default __exports__